/**
 * Facade for connecting with Infra
 */

let facade
// we run in Server Side
if (__IS_SERVER_SIDE__) {
  // Mock window
  global.window = {}

  // expose underscore from the actual package, because there is no Infra to inject it globally for us
  let underscore = require('underscore')
  global.window._ = underscore
  global._ = underscore

  // import Infra components from the actual package, because there is no Infra to inject it globally for us
  let InfraComponents = require('@master/webinfra-frontend-components')
  facade = {InfraComponents}
}
// we run in browser
else {
  // custom styles of agency app
  require('./style/application.less')
  require('./style/bootstrap.less')
  require('webapps-frontend-components/static/css/jquery-ui-1.10.1.custom/jquery-ui-1.10.1.custom.css')

  // use facade which exposes the global Infra components injected for us by the Infra globally
  facade = require('webapps-frontend-components/src/main/Infra/InfraFacadeShared')
}

export default facade



// WEBPACK FOOTER //
// ../src/InfraFacade.js